import OrderedList from '@tiptap/extension-ordered-list';
export const CustomOrderedList = OrderedList.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            listStyleType: {
                default: 'decimal',
                parseHTML: (element) => element.getAttribute('data-list-style') || element.style.listStyleType || 'decimal',
                renderHTML: (attributes) => {
                    if (!attributes.listStyleType || attributes.listStyleType === 'decimal') {
                        return {
                            'data-list-style': 'decimal',
                        };
                    }
                    return {
                        'data-list-style': attributes.listStyleType,
                        style: `list-style-type: ${attributes.listStyleType};`,
                    };
                },
            },
        };
    },
});
